import React, { useEffect, useState } from "react";
import { Wordmark } from "../components/Logo";
import { Menu, X } from "lucide-react";

const NAV = [
  { href: "#services", label: "Expertises" },
  { href: "#about", label: "À propos" },
  { href: "#menaces", label: "Fortinet EOL" },
  { href: "#secteurs", label: "Secteurs" },
  { href: "#contact", label: "Contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#0A1326]/85 backdrop-blur-xl border-b border-[#D4AF37]/15"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-5 md:px-8 lg:px-12 h-[68px] md:h-[76px] flex items-center justify-between">
        <a href="#top" data-testid="header-logo-link" className="shrink-0">
          <Wordmark variant="light" />
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-").replace(/à/g, "a")}`}
              className="text-[12px] font-semibold uppercase tracking-[0.18em] text-[#F5F5F5]/75 hover:text-[#D4AF37] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="#contact"
            data-testid="header-cta"
            className="beam-btn inline-flex items-center gap-2 bg-[#D4AF37] hover:bg-[#B8941F] text-[#0A1326] px-5 py-3 text-[12px] font-bold uppercase tracking-[0.16em] transition-colors rounded-[2px]"
          >
            Nous contacter
            <span>→</span>
          </a>
        </div>

        <button
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2 -mr-2 text-[#F5F5F5]"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0A1326] border-t border-[#D4AF37]/15" data-testid="mobile-menu">
          <div className="px-5 py-4 flex flex-col gap-2">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                className="py-3 border-b border-white/5 text-[#F5F5F5] font-semibold uppercase tracking-[0.16em] text-sm"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-header-cta"
              className="mt-3 bg-[#D4AF37] text-[#0A1326] text-center py-3 font-bold uppercase tracking-[0.16em] text-sm rounded-[2px]"
            >
              Nous contacter
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
